import { Coordinate } from 'ol/coordinate';
import * as proj from 'ol/proj';
import { DirectGeometryObject } from 'sdi/source';

const transformer = (source: proj.Projection, dest: proj.Projection) => {
    const t = (coord: number[]) =>
        coord.length > 1
            ? proj.transform(coord as Coordinate, source, dest)
            : coord;
    const transformGeometry = (
        geom: DirectGeometryObject
    ): DirectGeometryObject => {
        switch (geom.type) {
            case 'Point':
                return {
                    ...geom,
                    coordinates: t(geom.coordinates),
                };
            case 'MultiPoint':
                return {
                    ...geom,
                    coordinates: geom.coordinates.map(t),
                };
            case 'LineString':
                return {
                    ...geom,
                    coordinates: geom.coordinates.map(t),
                };
            case 'MultiLineString':
                return {
                    ...geom,
                    coordinates: geom.coordinates.map(l => l.map(t)),
                };
            case 'Polygon':
                return {
                    ...geom,
                    coordinates: geom.coordinates.map(r => r.map(t)),
                };
            case 'MultiPolygon':
                return {
                    ...geom,
                    coordinates: geom.coordinates.map(p =>
                        p.map(r => r.map(t))
                    ),
                };
        }
    };

    return transformGeometry;
};

export const wgs84toLB72 = transformer(
    //TODO rename
    new proj.Projection({ code: 'EPSG:4326' }),
    new proj.Projection({ code: 'EPSG:3857' })
);

export const wgs84toLB72Coords = (point: DirectGeometryObject) =>
    wgs84toLB72(point).coordinates;
